<template>
  <div class="editReport">
    <el-tabs v-model="current">
      <el-tab-pane label="人才推荐报告" name="first">
        <talent-recommend
          v-if="isShow.company && isShow.talent"
          :currentTab="current"
          :personCode="personCode"
          :projectId="projectId"
          :talentInfo="talentInfo"
          :companyInfo="companyInfo"
          @cancel="cancel"
        />
      </el-tab-pane>
      <el-tab-pane label="背景调查报告" name="second">
        <reference-check
          v-if="isShow.company && isShow.talent"
          :currentTab="current"
          :personCode="personCode"
          :projectId="projectId"
          :talentInfo="talentInfo"
          :companyInfo="companyInfo"
          @cancel="cancel"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import talentRecommend from './talentRecommend.vue'
import referenceCheck from './referenceCheck.vue'
import { getParticularsPersonByid } from '@/api/talent'
import { getCompanyInfo } from '@/api/projectCenter'

export default {
  name: 'EditReport',

  components: {
    talentRecommend,
    referenceCheck
  },

  data() {
    return {
      current: 'first',
      talentInfo: {}, // 人才信息
      // 公司信息
      companyInfo: {
        corporateName: '', // 公司名称
        recruitmentPosition: '', // 应聘职位
        projectConsultant: '' // 项目顾问
      },
      isShow: {
        talent: false, // 人才信息是否获取到
        company: false // 公司信息是否获取到
      }
    }
  },

  computed: {
    personCode() {
      return this.$route.query.personCode
    },
    projectId() {
      return Number(this.$route.query.projectId)
    },
    // 沟通列表tab的name
    tabName() {
      return this.$route.query.tabName
    },
    projectPositionType() {
      return this.$route.query.positionType
    },
    chidrenQueryInfo() {
      return JSON.parse(this.$route.query.chidrenQueryInfo)
    },
    searchInfo() {
      return JSON.parse(this.$route.query.searchInfo)
    }
  },

  created() {
    this.$store.commit('changeQueryInfo', this.searchInfo)
    this.$store.commit('projectCenter/changeCommunicateQueryInfo', this.chidrenQueryInfo)
    this.search()
    this.searchCompanyInfo()
  },

  methods: {
    async search() {
      const { data: res } = await getParticularsPersonByid({ PreCode: this.personCode })
      if (res.resultCode === 200) {
        this.talentInfo = res.data

        this.isShow.talent = true
      }
    },
    async searchCompanyInfo() {
      const { data: res } = await getCompanyInfo({ PreCode: this.personCode })
      if (res.resultCode === 200) {
        this.companyInfo.corporateName = res.data.projectCenterResult.corporateName
        this.companyInfo.recruitmentPosition = res.data.projectCenterResult.recruitmentPosition
        if (res.data.projectLeaderListResults.length) {
          this.companyInfo.projectConsultant = res.data.projectLeaderListResults.map((item) => {
            return item.projectLeader
          })
          this.companyInfo.projectConsultant = this.companyInfo.projectConsultant.join(',')
        }
        this.isShow.company = true
      }
    },
    cancel() {
      this.$router.push({
        name: 'Candidate',
        query: {
          tabName: this.tabName,
          id: this.projectId,
          positionType: this.projectPositionType,
          chidrenQueryInfo: JSON.stringify(this.chidrenQueryInfo),
          searchInfo: JSON.stringify(this.searchInfo)
        }
      })
    }
  }
}
</script>

<style></style>
